import { useTokenPermissions } from "./useTokenPermissions";
import { TokenPermissionModule } from "../constants/permissions";

export function useTranslationTokenPermissions() {
  const { canView, canEdit, canAccess } = useTokenPermissions();

  const canViewTranslation = (): boolean => {
    return canView(TokenPermissionModule.TRANSLATIONS);
  };

  const canEditTranslation = (): boolean => {
    return canEdit(TokenPermissionModule.TRANSLATIONS);
  };

  const canAccessTranslation = (): boolean => {
    return canAccess(TokenPermissionModule.TRANSLATIONS);
  };

  return {
    canViewTranslation,
    canEditTranslation,
    canAccessTranslation,
  };
}
